import { onSnapshot } from 'mobx-state-tree';
import Nav from '../stores/Nav'
// import Pubnub from '../stores/PubNub'

onSnapshot(Nav, snapshot => { sessionStorage.setItem("chat-nav", JSON.stringify(snapshot)) })
// onSnapshot(Pubnub, snapshot => { sessionStorage.setItem("chat-channels", JSON.stringify(snapshot)) })